// eslint-disable-next-line import/prefer-default-export
export const simpleNumberFormatter = (value: number) => {
  const numberFormatter = new Intl.NumberFormat('en-US')
  return numberFormatter.format(value)
}

export const compactNumberFormatter = ({
  value,
  precise = true
}: {
  value: number
  precise?: boolean
}) => {
  const formatter = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
    minimumFractionDigits: 0,
    // @ts-ignore Safari 15.6.1+ workaround
    roundingPriority: 'lessPrecision'
  })

  // Precise mode: format as-is
  if (precise) {
    return formatter.format(value)
  }

  // Imprecise mode: round down to bucket and add "+"
  const buckets = [1e8, 5e7, 1e7, 5e6, 1e6, 5e5, 1e5, 5e4, 1e4, 5e3, 1e3, 500, 100, 50, 10, 0]
  const roundedValue = buckets.find((b) => b <= value) ?? 0
  const formatted = formatter.format(roundedValue)

  return roundedValue > 0 ? `${formatted}+` : formatted
}
